'use client';

import { COLORS } from '@/constants';
import { useMasterAdmin } from '@/contexts/masterAdmin';
import { Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

const HEADER_HEIGHT = 71;
const HEADER_MOBILE_HEIGHT = 77;
export const BANNER_HEIGHT = 42;

const Banner = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  z-index: 1100;
  background: ${COLORS['primary/910']};
  color: ${COLORS['white']};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 7px 24px;
  @media (max-width: 1280px) {
    top: ${HEADER_MOBILE_HEIGHT}px;
  }
`;

const BannerSpacer = styled.div`
  height: ${BANNER_HEIGHT}px;
`;

const ReturnButton = styled(Button)`
  && {
    color: ${COLORS['white']};
    border: 2px solid ${COLORS['neutral/600']};
    border-radius: 4px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
    min-width: 0;
    line-height: 1.5;
    height: 28px;

    &:hover {
      border-color: ${COLORS['neutral/200']};
    }
  }
`;

export const ImpersonationBanner = () => {
  const t = useTranslations('masterAdmin');
  const { isImpersonating, impersonatedBroker, returnToMasterAdmin } = useMasterAdmin();

  if (!isImpersonating || !impersonatedBroker) return null;

  return (
    <>
      <Banner role="status">
        <Typography fontSize={13} fontWeight={500} color={COLORS['neutral/200']}>
          {t('impersonationBannerText', {
            name: impersonatedBroker.name,
            office: impersonatedBroker.officeName,
          })}
        </Typography>
        <ReturnButton size="small" onClick={returnToMasterAdmin}>
          {t('impersonationBannerReturn')}
        </ReturnButton>
      </Banner>
      <BannerSpacer />
    </>
  );
};
